module.exports = __webpack_public_path__ + "img/744.e6287d7f.jpg";